var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"sm12":"","md8":""}},[_c('stepper',{on:{"loadRegistration":_vm.loadRegistration}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }